import React from "react";
import ref from "../images/rentcap2.svg";

const Logo = () => <img alt="Logo" src={ref} />;
export default Logo;
